<script setup lang="ts">
import type { EventTicket } from '@/types/event';

defineProps({
	tickets: {
		type: Array as PropType<EventTicket[]>,
		default: () => [],
	},
});

function checkTicketStatus(ticket: EventTicket) {
	return ticket.status === EVENT_TICKET_STATUS.SOLD_OUT || ticket.status === EVENT_TICKET_STATUS.SUSPENDED;
}
</script>

<template>
  <div class="tickets">
    <div
      v-for="(ticket, index) in tickets"
      :key="index"
      :class="['ticket-item', 'text-sm', 'text-regular', {
        '--sold-out': checkTicketStatus(ticket),
      }]"
    >
      <div class="ticket-name">
        <span class="text-wrap">{{ ticket?.name }}</span>
        <TokenGatedTooltipIcon v-if="ticket.requiresTokenGates" />
        <span
          v-if="ticket.status === EVENT_TICKET_STATUS.ON_HOLD"
          class="text-disabled"
        >
          (Paused)
        </span>
      </div>
      <div
        v-if="ticket.status === EVENT_TICKET_STATUS.SOLD_OUT || ticket.status === EVENT_TICKET_STATUS.SUSPENDED"
        class="text-right"
      >
        Sold out
      </div>
      <div
        v-else
        class="text-right"
      >
        {{ (ticket.price && ticket.price > 0) ? formatCurrency(ticket.price, ticket.currency?.code) : 'Free' }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tickets {
    display: flex;
    flex-direction: column;
    margin: rem(6) 0;

    .ticket-item {
        display: grid;
        grid-template-columns: auto minmax(rem(55), auto);
        justify-content: space-between;
        align-items: center;
        gap: spacings-get(2);
        margin-bottom: spacings-get(2);
        color: colors-get(gray, 700);

        &.--sold-out {
          color: colors-get(gray, 300);
        }
    }

    .ticket-name {
      display: flex;
      align-items: center;
      column-gap: spacings-get(2);
    }
}
</style>